import * as React from 'react';
const RitenzioneIdricaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M59.3 132.66c5.79.46 11.05 1.28 15.02 3.35.17.09.34.18.51.28l.27.15h0c1.71.92 3.51 1.83 5.39 2.74 5.32 2.58 9.65 3.89 14.88 4.04 6.43.18 17.64-5.22 26.24-9.95 16.54-9.09 25.78-14.9 21.26-18.6-4.26-3.49-17.03 4.32-27.96 9.87"
      className="prefix__cls-2"
    />
    <path
      d="M79.61 124.9c7.76.62 12.76 2.84 19.56 5.16 6.95 2.38 11.39 3.89 12.55.05 1.22-4.04-7.09-10.21-15.83-13.73-6.29-2.54-10.74-7.54-16.6-8.31-4.8-.63-9.18.52-12.65 1.66-4.11 1.35-7.51 2.2-10.64 2.72M132.64 111.4c-.63-.69-1.85-1.1-3.61-1.1-4.74 0-12.11 5.02-18.75 9.24M121.74 108.41c-.55-.12-1.22-.16-2.01-.09-3.79.33-8.01 4.25-13.67 8.4M111.53 107.96c-.52-.1-1.16-.1-1.91 0-2.83.42-3.98 2.61-8.23 6.07"
      className="prefix__cls-2"
    />
    <path
      d="M109.17 88.06c-.56 3.16-2.51 5.84-5.19 7.39M109.22 82.81l-.05-1.09"
      className="prefix__cls-1"
    />
    <path
      d="M99.09 56.78S115 69.8 115 86.74c0 8.79-7.12 15.91-15.91 15.91s-15.91-7.12-15.91-15.91c0-16.94 15.91-29.96 15.91-29.96"
      className="prefix__cls-1"
    />
  </svg>
);
export default RitenzioneIdricaIcon;
